import React from 'react';
import laptopImage from '../assets/undraw_hello_re_3evm.svg';
import logoImage from '../assets/logo.png';

function Header() {
  return (    
      <header className="hero">
      <div className="header-top">
        <img src={logoImage} alt="Logo do Studio" className="logo" />
      </div>

      <div className="hero-content">
        <div className="hero-left">
          <h1>Desenvolvendo mundos, um jogo de cada vez.</h1>
          <p class="hero-subtext">
            Somos um estúdio apaixonado por criar experiências únicas que combinam mecânicas bem construídas, identidade visual marcante e acessibilidade. Trabalhamos com diferentes estilos e plataformas, sempre buscando entregar jogos envolventes e bem otimizados.
Cada projeto é desenvolvido com atenção aos detalhes, pensando no que realmente importa: a diversão do jogador.


        </p>
          {/* <a href="#games"><button className="cta-button">Conheça nossos jogos</button></a> */}
        </div>
        <div className="hero-right">
          <img src={laptopImage} alt="Ilustração de laptop" className="hero-image" />
        </div>
      </div>
    </header>
  );
}

export default Header;